<script setup>
defineProps({
  block: {
    type: Object,
    default: () => ({}),
  },
  maxContent: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div class="title-text p-top-xl-1 max">
    <div :class="['container', { 'max-content': maxContent }]">
      <!-- eslint-disable vue/no-v-html -->
      <div class="left">
        <div class="title-base1 title" v-html="block.titolo" />
        <div v-if="block.immagineDecorativa" class="decoration-img-container">
          <DecorationImage
            :image="block.immagineDecorativa.immagine"
            :type="block.immagineDecorativa.titolo"
          />
        </div>
      </div>
      <div class="right">
        <div class="text-s-1-b" v-html="block.testo" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TitleText',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
